import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useNextTranslation } from "hooks/useTranslation";

import { Link } from "@holibob-packages/ui-core/navigation";

import { useReturnLink } from "../hooks/usePersistedQueryParams";

const StyledLink = styled(Link)(({ theme }) => ({
    color: theme.palette.primary.main + "!important",
}));

export default function ReturnLink() {
    const returnLink = useReturnLink();
    const [t] = useNextTranslation("product");

    if (!returnLink || typeof returnLink !== "string") {
        return null;
    }

    return (
        <Button
            color="primary"
            component={StyledLink}
            disableElevation
            href={returnLink}
            startIcon={<ChevronLeftIcon viewBox="0 0 22 22" fontSize="large" />}
        >
            {t("returnLink.label")}
        </Button>
    );
}
